import React, { useState } from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import PositionBookmarkListItem from '@components/common/positionBookmarkListItem';
import { useAccCenterPositionsRecommend } from '@repository/acc';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useAccResults } from '../query/useApply';
import AccRecommendPositionListVO from '@domain/vo/acca/test/AccRecommendPositionListVO';
import { AccaResultEnum, AccaResultTypeArray } from '@domain/constant/acca/AccaResultType';
import { RouteUrl } from '@utils/routeUtil';
import Banner from '@components/acca/test/banner';

import classnames from 'classnames/bind';
import styles from './positionList.module.scss';
const cx = classnames.bind(styles);

// 역검 결과 없는 경우
const NoAccaResult = () => {
  return (
    <div className={cx('section')}>
      <Banner />

      <div className={cx('sectionInner')}>
        <div className={cx('positionListArea')}>
          <strong className={cx('sectionTitle')}>역검 결과 맞춤형 포지션 추천</strong>

          <div className={cx('emptyArea')}>
            역검 결과를 기반으로 포지션을 추천해드려요.
            <Link href={RouteUrl.ACCA_TEST_LIST} legacyBehavior>
              <a className={cx('btnAcca')} target="_blank" role="button">
                역검 응시하기
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

// 조건에 맞는 포지션이 없는 경우
const EmptyList = () => {
  return (
    <div className={cx('section')}>
      <Banner />

      <div className={cx('sectionInner')}>
        <div className={cx('positionListArea')}>
          <strong className={cx('sectionTitle')}>역검 결과 맞춤형 포지션 추천</strong>

          <div className={cx('emptyArea')}>역검 결과에 딱 맞는 포지션이 없어요.</div>
        </div>
      </div>
    </div>
  );
};

const PositionList = () => {
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;
  const { data: accResults } = useAccResults(isLogin);
  const isResults = !!accResults?.profileResultType;
  //역검 분석 완료 내역 없을 경우 "'역검 유형’이 많이 본 포지션"로 출력
  const accType = isResults ? AccaResultEnum.ACC_RESULT_TYPE : AccaResultEnum.ACC_RECOMMEND_JOB_GROUP;
  const [selectedAccType, setSelectedAccType] = useState(accType);
  const { data: recommendData } = useAccCenterPositionsRecommend(selectedAccType, isLogin && isResults);
  const isRecommendPosition = !!recommendData?.positions?.length;

  const positionListItems = recommendData?.positions?.map((item, idx) => {
    //key : 캐싱 문제로 북마크 상태 변경안되는 문제가 있어 key에 북마크 값 추가
    return <PositionBookmarkListItem key={`${item.sn}_${item.bookmarkYn}`} index={idx} data={item} />;
  });

  const setOtherAccType = () => {
    setSelectedAccType((prev) => {
      const otherType = AccaResultTypeArray.find((type) => type !== prev);
      return otherType ?? prev;
    });
  };

  // [D] 비로그인 경우
  if (!isLogin) return null;

  // [D] 로그인 && 역검 결과 없는 경우
  if (isLogin && !isResults) return <NoAccaResult />;

  // [D] 조건에 맞는 포지션이 없는 경우
  if (!isRecommendPosition) return <EmptyList />;

  return (
    <div className={cx('section')}>
      <Banner />

      <div className={cx('sectionInner')}>
        <div className={cx('positionListArea')}>
          <div className={cx('sectionDescArea')}>
            <strong className={cx('sectionTitle')}>역검 결과 맞춤형 포지션 추천</strong>
            <p className={cx('sectionDesc')}>
              {AccRecommendPositionListVO.getSectionDesc(accResults?.profileResultType, selectedAccType)}
            </p>
            <a className={cx('sectionLink')} role="button" onClick={setOtherAccType}>
              <Icon name="resetLight" width={24} height={24} />
              새로고침
            </a>
          </div>

          <div className={cx('positionList')}>{positionListItems}</div>
        </div>
      </div>
    </div>
  );
};

export default PositionList;
